import { render, staticRenderFns } from "./IconCreateShortcut.vue?vue&type=template&id=b8a9ca5e&scoped=true"
import script from "./IconCreateShortcut.vue?vue&type=script&lang=js"
export * from "./IconCreateShortcut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a9ca5e",
  null
  
)

export default component.exports